import { render, staticRenderFns } from "./BellList.vue?vue&type=template&id=acccbf0c&scoped=true"
import script from "./BellList.vue?vue&type=script&lang=js"
export * from "./BellList.vue?vue&type=script&lang=js"
import style0 from "./BellList.vue?vue&type=style&index=0&id=acccbf0c&prod&lang=css"
import style1 from "./BellList.vue?vue&type=style&index=1&id=acccbf0c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acccbf0c",
  null
  
)

export default component.exports